<adaa-data-table
    #governmentDirectionsTable
    [titleHeader]="'breadcrumbs.directions_module.list'"
    [configKey]="constants.MAIN_TABLE_LIST_CONF_KEY.GOV_DIRECTIONS"
    [apiPrefix]="'govdirection'"
    [paramsString]="paramsString()"
    [itemTypeId]="constants.CONSTANT_PERMISSIONS.GOVERNMENT_DIRECTIONS"
    (actionClicked)="actionClicked($event)"
    (addNewClicked)="addNewClicked()"
></adaa-data-table>
